import { PURCHASE_ORDER_PAGE } from "routes/route.constant";
import PurchaseOrder from "./PurchaseOrder";

const route = {
  path: PURCHASE_ORDER_PAGE,
  element: PurchaseOrder,
};

export default route;
